export function OrganizationSchema() {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩国漫画网',
    url: 'https://www.koreacomic.cn',
    description: '韩国漫画网独家首发最新韩漫。所有作品均可免费在线阅读全集，无广告干扰。',
    email: 'contact@koreacomic.cn',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CN',
      addressLocality: '北京',
    },
    sameAs: [],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function WebsiteSchema() {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩国漫画网',
    url: 'https://www.koreacomic.cn',
    description: '韩国漫画网独家首发最新韩漫。所有作品均可免费在线阅读全集。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.koreacomic.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

interface WebPageSchemaProps {
  title: string;
  description: string;
  url: string;
  datePublished?: string;
  dateModified?: string;
}

export function WebPageSchema({ title, description, url, datePublished, dateModified }: WebPageSchemaProps) {
  const data: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description: description,
    url: url,
  };
  if (datePublished) data.datePublished = datePublished;
  if (dateModified) data.dateModified = dateModified;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

interface ArticleSchemaProps {
  id: string;
  title: string;
  description: string;
  author: string;
  datePublished: string;
  dateModified: string;
  imageUrl: string;
  category: string;
}

export function ArticleSchema({
  id,
  title,
  description,
  author,
  datePublished,
  dateModified,
  imageUrl,
  category,
}: ArticleSchemaProps) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description,
    author: {
      '@type': 'Person',
      name: author,
    },
    datePublished: datePublished,
    dateModified: dateModified,
    image: imageUrl,
    articleSection: category,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://www.koreacomic.cn/comic/${id}`,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function FAQSchema() {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩国漫画网的所有漫画都是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的！韩国漫画网上的所有漫画作品均可免费在线阅读全集，我们承诺永久免费，无任何隐藏收费。',
        },
      },
      {
        '@type': 'Question',
        name: '韩国漫画网多久更新一次漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们与韩国各大漫画平台保持同步更新，热门连载作品每周都会准时更新。具体更新频率视作品而定，通常在每周二至周五更新。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在韩国漫画网上找到我想看的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过网站顶部的搜索框直接搜索漫画名称，也可以通过分类页面按类型浏览，包括恋爱、奇幻、动作、搞笑、悬疑等多种分类。',
        },
      },
      {
        '@type': 'Question',
        name: '韩国漫画网有广告吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩国漫画网致力于为读者打造纯净的阅读环境。我们严格控制广告数量，绝不会出现弹窗广告或影响阅读体验的干扰性广告。',
        },
      },
      {
        '@type': 'Question',
        name: '可以在手机上阅读韩国漫画网的漫画吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '可以！韩国漫画网针对移动设备进行了全面优化，您可以在手机、平板等任何设备上流畅阅读漫画，随时随地享受阅读乐趣。',
        },
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}